import axios from 'axios'
import type { pkg, pkgfilter , addpkg } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'package'

export const readPkgListAPI = async (pkgfilter: pkgfilter): Promise<pkg[]> => {
    const response = await axios.get(baseurl + url, {
        params: {
            cmd: 'list',
            ...pkgfilter
        }
    })
    console.log("readPkgListAPI 응답:", response.data)
    return response.data.data
}

export const addpkgAPI = async (addpkg: addpkg): Promise<number> => {
    const response = await axios.get(baseurl + url, {
        params: {
            cmd: 'add',
            ...addpkg
        }
    })
    console.log("addpkgAPI 응답:", response.data)
    return response.data
}

export const updatepkgAPI = async (pkg: pkg): Promise<boolean> => {
    const response = await axios.get(baseurl + url, {
        params: {
            cmd: 'update',
            ...pkg
        }
    })
    console.log("updatepkgAPI 응답:", response.data)
    return response.data
}

export const deletepkgAPI = async (id: number): Promise<boolean> => {
    const response = await axios.get(baseurl + url, {
        params: {
            cmd: 'delete',
            id: id,
        }
    })
    console.log("deletepkgAPI 응답:", response.data)
    return response.data
}

export const paginationpkgAPI = async (pkgfilter: pkgfilter): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      ...pkgfilter
    }
  })
  console.log("paginationpkgAPI 응답:", response.data)
  return response.data.data.totalpage
}   
    
